export const resetUsefulLinksObj = () => {
  return {
    type: 'RESET_USEFUL_LINKS_OBJ',
    payload: {},
  }
}
export const resetUsefulLinksStatus = (reset) => {
  return {
    type: 'RESET_USEFUL_LINKS_STATUS',
    payload: reset,
  }
}

export const usefulLinksError = (error) => {
  return {
    type: 'USEFUL_LINKS_ERROR',
    payload: error,
  }
}

export const getUsefulLinks = (data) => {
  return {
    type: 'GET_USEFUL_LINKS',
    payload: data,
  }
}
export const setUsefulLinks = (data) => {
  return {
    type: 'SET_USEFUL_LINKS',
    payload: data,
  }
}

export const updateUsefulLinks = (data) => {
  return {
    type: 'UPDATE_USEFUL_LINKS',
    payload: data,
  }
}
export const updatedUsefulLinks = (data) => {
  return {
    type: 'UPDATED_USEFUL_LINKS',
    payload: data,
  }
}
